import React, { Component } from 'react';
import { Image, Modal, Button, ButtonGroup, Row, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { contractReviewerActions as actions } from '../../actions';
import { contractReviewerConstants } from '../../constants';
import '../../content/css/ContractReviewer.css';
import LoadingListener from '../../helpers/loadingListener';
import { LoadingIcon } from '../LoadingIcon';

var page = require("../../content/images/page_icon.png");

class CompareDocumentsModal extends Component {
    constructor(props, context) {
        super(props, context);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSelectDocumentClick = this.handleSelectDocumentClick.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.resetSelection = this.resetSelection.bind(this);
        this.handleExitCompareMode = this.handleExitCompareMode.bind(this);

        this.state = {
            documentId: "",
            documentReady: false,
            show: false
        };

        this.loadingListener = new LoadingListener([contractReviewerConstants.COMPARE_DOCUMENTS_REQUEST, contractReviewerConstants.GET_TEMPLATE_DOCUMENTS_LIST_REQUEST]);
    }

    componentDidMount() {
        if (this.props.templateDocuments.length == 0) this.props.requestTemplateDocumentsList();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.documentId != prevState.documentId) {
            if (this.state.documentId == '')
                this.setState({ documentReady: false });
            else if (!this.props.analyzedDocuments[this.state.documentId] || !this.props.analyzedDocuments[`${this.props.id}-${this.state.documentId}`]) {
                this.setState({ documentReady: false });
                this.props.requestCompareDocuments(this.state.documentId, this.props.id);
                //this.props.requestComparisonDocumentAnalysis(this.state.documentId);
            }
            else this.setState({ documentReady: true });
        }

        if (this.props.analyzedDocuments != prevProps.analyzedDocuments) {
            if (!this.props.analyzedDocuments[this.state.documentId] || !this.props.analyzedDocuments[`${this.props.id}-${this.state.documentId}`]) {
                this.setState({ documentReady: false });
                //this.props.requestCompareDocuments(this.state.documentId, this.props.id);
                //this.props.requestComparisonDocumentAnalysis(this.state.documentId);
            }
            else this.setState({ documentReady: true });
        }
    }

    getCurrentDocument() {
        let doc = this.props.analyzedDocuments[this.state.documentId];
        return doc ? doc : {
            highlights: [],
            missingHighlights: [],
            segments: []
        };
    }

    handleClose() {
        this.setState({ show: false });
    }

    handleShow() {
        this.setState({ show: true });
    }

    handleSelectDocumentClick(id) {
        this.setState({ documentId: id });
    }

    handleConfirm() {
        if (this.state.documentReady) {
            this.props.onConfirm(this.state.documentId);
            this.handleClose();
        }
    }

    resetSelection() {
        this.setState({ documentId: "", documentReady: false });
    }

    handleExitCompareMode() {
        this.handleClose();
        this.resetSelection();
        this.props.onExitMode();
    }

    getPages() {
        let docs = this.props.documents ? this.props.documents : [];
        docs = docs.slice(docs.length - 20, docs.length);
        docs = docs.reverse();
        return docs.map((doc, i) => (
            <div className="document">
                <span className="document-id">ID: {doc.id}</span>
                <Image className="page" src={page} fluid onClick={() => this.handleSelectDocumentClick(doc.id)} />
                <span>{doc.fileName}</span>
            </div>
        ));
    }

    getTemplatePages() {
        let docs = this.props.templateDocuments.reverse();
        return docs.map((doc, i) => (
            <div className="document">
                <span className="document-id">ID: {doc.id}</span>
                <Image className="page" src={page} fluid onClick={() => this.handleSelectDocumentClick(doc.id)} />
                <span>{doc.fileName}</span>
            </div>
        ));
    }

    render() {
        let isLoading = this.loadingListener.isLoading(this.props.isLoading);
        let doc = this.getCurrentDocument();

        return (
            <div>
                <ButtonGroup>
                    <Button className="compare-documents-btn" onClick={this.handleShow}>{this.state.documentReady ? "Change template (BETA)" : "Compare to template (BETA)"}</Button>
                    {this.state.documentReady &&
                        <Button className="compare-documents-btn" onClick={this.handleExitCompareMode}><Glyphicon glyph="remove" /></Button>
                    }
                </ButtonGroup>
                <Modal className="compare-documents-modal" scrollable={true} show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Select a template document to compare with (BETA)</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {isLoading &&
                            <LoadingIcon />
                        }

                        {!isLoading &&
                            <React.Fragment>
                                {this.state.documentReady &&
                                    <React.Fragment>
                                        <strong>Your selected template</strong>
                                        <Row className="pages">
                                            <div className="document">
                                                <span className="document-id">ID: {this.state.documentId}</span>
                                                <Image className="page" src={page} fluid onClick={() => this.handleSelectDocumentClick(this.state.documentId)} />
                                                <span>{doc.fileName}</span>
                                            </div>
                                            <Button className="change-template-btn" onClick={this.resetSelection}>Change template</Button>
                                        </Row>
                                    </React.Fragment>
                                }
                                {!this.state.documentReady &&
                                    <React.Fragment>
                                        {this.props.templateDocuments &&
                                            <React.Fragment>
                                                <strong>Your template documents</strong>
                                                <Row className="pages">
                                                    {this.getTemplatePages()}
                                                </Row>
                                                <hr />
                                            </React.Fragment>
                                        }
                                        <Row className="pages">
                                            {this.getPages()}
                                        </Row>
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        {!isLoading && this.state.documentReady &&
                            <Button onClick={this.handleConfirm}>Confirm</Button>
                        }
                        <Button onClick={this.handleClose}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default connect(
    state => state.contractReviewer,
    dispatch => bindActionCreators(actions, dispatch)
)(CompareDocumentsModal);


// WEBPACK FOOTER //
// ./src/components/DocumentViewer/CompareDocumentsModal.js